import { useLocation, useNavigate } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'

import { UserContext } from '../contexts'
import Dashboard from '../containers/dashboard'
import CryptoManagement from '../containers/crypto-management'

const CryptoPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { userSession } = useContext(UserContext)
  const [displayElements, setDisplayElements] = useState<boolean>(false)

  useEffect(() => {
    if (!userSession) {
      return
    }

    if ((userSession?.role !== 'super-admin' && userSession?.role !== 'admin') || !userSession?.subRole || (userSession?.subRole && userSession?.subRole !== 'crypto-specialist')) {
      navigate('/404')
    } else {
      setDisplayElements(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, userSession])

  return <Dashboard>{displayElements ? <CryptoManagement /> : <></>}</Dashboard>
}

export default CryptoPage
